module.exports = __webpack_public_path__ + "img/debit.d5899403.svg";